/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { RelatedDevice, RelatedDevice$inboundSchema } from "./relateddevice.js";

/**
 * A section of related devices
 */
export type RelatedDeviceSection = {
  /**
   * The devices to display in the section
   */
  devices: Array<RelatedDevice>;
  /**
   * The title of the section
   */
  title?: string | undefined;
};

/** @internal */
export const RelatedDeviceSection$inboundSchema: z.ZodType<
  RelatedDeviceSection,
  z.ZodTypeDef,
  unknown
> = z.object({
  devices: z.array(RelatedDevice$inboundSchema),
  title: types.optional(types.string()),
});

export function relatedDeviceSectionFromJSON(
  jsonString: string,
): SafeParseResult<RelatedDeviceSection, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => RelatedDeviceSection$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'RelatedDeviceSection' from JSON`,
  );
}
